const deprecateSplittedBooleanEnumProperty = (
  componentName,
  newProperty,
  oldPropertiesMap
) => {
  return oldPropertiesMap.reduce((acc, { oldName, oldValue, newValue }) => {
    if (acc) {
      return acc;
    } else if (oldValue) {
      if (process.env.NODE_ENV === "development") {
        console.warn(
          `${componentName} property "${oldName}" is deprecated. Please use ${newProperty}="${newValue}" instead.`
        );
      }
      return newValue;
    } else {
      return acc;
    }
  }, undefined);
};

export default deprecateSplittedBooleanEnumProperty;
